import graphqlClient from '../../api/axios_interceptor';
import { LoginMutation, fetchUserQuery } from '../../api/graphql/queries/authentication';
import { setTokens } from '../../utils/customStorage';
import {
    LOG_IN_USER, FETCH_USER
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';


export const loginUserMiddlware = async (action) => {
    try{
        const payload = action.payload;
        const query = LoginMutation(payload.username, payload.password);
        await graphqlClient({
            data: {
            query
            }
        }).then((queryResult) => {
                if (queryResult.data.errors) {
                    action = updateActionErrors(action, queryResult.data.errors);
                } else if(queryResult.data.data.tokenAuth.success === true){
                    const accessToken = queryResult.data.data.tokenAuth.token;
                    const refreshToken = queryResult.data.data.tokenAuth.refreshToken;
                    if (accessToken) {
                        setTokens(accessToken, refreshToken);
                    }
                    action.payload = {
                        ...action.payload,
                        ...queryResult.data.data.tokenAuth
                    }
                }else{
                    action = updateActionErrors(action, "Invalid username or password!");
                }
        });
    }catch(error){
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const fetchUserMiddleware = async (action) => {
    try{
        await graphqlClient({
            data: {
            query: fetchUserQuery()
            }
        }).then((queryResult) => {
                if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
                } else if(queryResult.data.data.fetchUser){
                    action.payload = {
                        ...action.payload,
                        user: queryResult.data.data.fetchUser
                    }
                }
        });
    }catch(error){
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const userMiddleware = storeAPI => next => async action => {
    switch(action.type){
        case LOG_IN_USER:
            action = await loginUserMiddlware(action);
            break;
        case FETCH_USER:
            action = await fetchUserMiddleware(action);
            break;
    }
    return next(action);
}